<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <kendo-autocomplete
      class="w-100"
      [attr.name]="config.formControlName"
      [value]="text()"
      [disabled]="disabled()"
      [data]="suggestions()"
      [filterable]="true"
      [suggest]="false"
      [clearButton]="true"
      [placeholder]="config?.placeholder || ''"
      (filterChange)="onFilterChange($event)"
      (valueChange)="onValueChange($event)"
      (blur)="onBlur()"
    ></kendo-autocomplete>
    @if (scopeHint()) {
      <div class="sublocation-hint">{{ scopeHint() }}</div>
    }
    @if (state().unknown) {
      <div class="sublocation-warning">
        Not a listed sub-location. It saves as typed.
      </div>
    }
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
    </div>
  }
</div>
